import { render } from "./ShopkeeperAddModal.vue?vue&type=template&id=1ff5d4c6"
import script from "./ShopkeeperAddModal.vue?vue&type=script&lang=js"
export * from "./ShopkeeperAddModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__